import { UserRoleEnum } from "../enums/role";
import ApiService from "../services/api";
import RoutingApiService from "../services/routingApi";

export interface IUserProfile {
    name: string;
    firstName?: string;
    lastName?: string;
    email: string;
    group?: string;
    accountId?: string;
}

export const fetchUser = async (userId: string): Promise<IUserProfile | undefined> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/users/${userId}`);
        if (response.status === 200) {
            return {
                name: response.data.firstName + " " + response.data.lastName,
                firstName: response.data.firstName,
                lastName: response.data.lastName,
                email: response.data.email,
                group: response.data.group,
                accountId: response.data.accountId,
            };
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

export const fetchUserRole = async (): Promise<UserRoleEnum | undefined> => {
    const apiService = new ApiService();
    
    try {
        const response = await apiService.get<any>(`/users/role`);
        if (response.status === 200) {
            return response.data.role;
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}

export const fetchUserId = async (userProfile: any): Promise<string | undefined> => {
    const userId = userProfile?.sub?.split(":")[1];
    return userId ?? undefined;
}

export const fetchRoutingUserProfileId = async (): Promise<string | undefined> => {
    const routingApiService = new RoutingApiService();

    try {
        const response = await routingApiService.get<any>(`/users/unique/profile`);
        if (response.status === 200) {
            return response.data.id;
        } else return undefined;
    } catch (error) {
        console.error(error);
        return undefined;
    }
}